import { BlockService } from '@blocksuite/block-std';

import type { PiqueMermaidBlockModel } from './mermaid-block';

export class PiqueMermaidBlockService extends BlockService<PiqueMermaidBlockModel> {
  override mounted(): void {
    super.mounted();
  }
}
